var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSickLeave = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2598_43467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4974 2.5H4.83073C3.91406 2.5 3.1724 3.25 3.1724 4.16667L3.16406 15.8333C3.16406 16.75 3.91406 17.5 4.83073 17.5H16.4974C17.4141 17.5 18.1641 16.75 18.1641 15.8333V4.16667C18.1641 3.25 17.4141 2.5 16.4974 2.5ZM14.8307 11.6667H12.3307V14.1667C12.3307 14.625 11.9557 15 11.4974 15H9.83073C9.3724 15 8.9974 14.625 8.9974 14.1667V11.6667H6.4974C6.03906 11.6667 5.66406 11.2917 5.66406 10.8333V9.16667C5.66406 8.70833 6.03906 8.33333 6.4974 8.33333H8.9974V5.83333C8.9974 5.375 9.3724 5 9.83073 5H11.4974C11.9557 5 12.3307 5.375 12.3307 5.83333V8.33333H14.8307C15.2891 8.33333 15.6641 8.70833 15.6641 9.16667V10.8333C15.6641 11.2917 15.2891 11.6667 14.8307 11.6667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2598_43467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.664062)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSickLeave, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sickLeave.0d8b83e5.svg";
export { ForwardRef as ReactComponent };